import { useState, useEffect, FunctionComponent } from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect } from "react-redux";
import { NEWS_COLUMNS } from "../../Values/tables";
import CustomTable from "../../Components/CustomTable/CustomTable";
import styles from './NewsPanel.module.css'
import { fetchNewsSuperAdmin } from "../../Services/organizations";
import { themeColors } from "../../Components/theme";
import Loading from "../../Components/Loading/Loading";
import { useMediaQuery } from "@material-ui/core";
import { searchNewsData } from "../../Values/utils";

type props = {
  history: any;
  user: any;
  theme: any;
};

const NewsPanelReplicateAdmin: FunctionComponent<props> = ({ history, user, theme }) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [news, setNews] = useState<any[] | undefined>(undefined);
  const [status, setStatus] = useState("ALL");
  const [owner, setOwner] = useState(false);
  const [clearFilterTable, setClearFilterTable] = useState(false);

  useEffect(() => {
    fetchNewsSuperAdmin((val) => setNews(val));
  }, []);

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  useEffect(() => {
    if (news) {
      let data: any[] = [];
      news.forEach((item) => {
        data.push(item);
      });
      setFilterData(data);
    }
  }, [news]);

  useEffect(() => {
    if (news) {
      const data = searchNewsData(
        news,
        searchQuery
      );
      setFilterData(data);
    }
    // eslint-disable-next-line
  }, [searchQuery, news]);

  useEffect(() => {
    if (selectedRows.length > 0) {
      setOwner(true);
    } else if (selectedRows.length === 0) {
      setOwner(false);
    }
  }, [selectedRows]);

  const topBarStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, width: "97%" }
  const parentStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark }

  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...parentStyles }}>
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...topBarStyles }}>
          {news === undefined && <Loading />}
          <Topbar
            history={history}
            title={"View News"}
            path={"/addUsers"}
            onChange={(val) => setsearchQuery(val)}
            filterText="Status"
            setColumnModal={(data) => setColumnModal(data)}
            show={false}
            owner={owner}
            showStatusBox={true}
            setStatus={(status) => setStatus(status)}
            status={status}
            clearFilter={handleClearFilter}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
          <CustomTable
            tableColumns={NEWS_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="NEWS VIEW"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchQuery(val)}
            clearFilterTable={clearFilterTable}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    theme: state.theme.isLightMode,
    user: state.user.data,
  };
};
export default connect(mapStateToProps)(NewsPanelReplicateAdmin);